import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompositePageComponent } from './container/composite-page/composite.component';
import { SectionDetailsComponent } from './container/section-details/section-details.component';
import { SectionDetailsTabLayoutComponent } from './container/section-details-tab-layout/section-details-tab-layout.component';
import { SharedModule } from '../shared.module';
import { SinglePageComponent } from './container/single-page/single-page.component';
import { TabPageComponent } from './container/tab-page/tab-page.component';
import { TablistHeaderComponent } from './container/tablist/container/tablist-header/tablist-header.component';
import { TabsDropdownComponent } from './components/tabs-dropdown-control/tabs-dropdown.component';



@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CompositePageComponent,
        SectionDetailsComponent,
        SinglePageComponent,
        SectionDetailsTabLayoutComponent,
        TabPageComponent,
        TablistHeaderComponent,
        TabsDropdownComponent
    ],
    exports: [
        CompositePageComponent,
        SectionDetailsComponent,
        SinglePageComponent,
        SectionDetailsTabLayoutComponent,
        TabPageComponent,
        TablistHeaderComponent,
        TabsDropdownComponent,
    ]
})
export class CentralPageModule { }
